import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

import { DotCmsUveFacade } from '../../../facades/dot-cms-uve.facade';
import { VideoContentlet } from '../../../models/dot-cms-uve-contentlet.model';
import { tryProcessVideo } from '../../../utils/dot-cms-uve-utils';

@Component({
  selector: 'custom-dot-cms-youtube-video',
  templateUrl: './dot-cms-uve-youtube-video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, NgClass, AsyncPipe],
})
export class DotCmsUveYoutubeVideoComponent {
  contentlet = input.required<VideoContentlet>();

  // constructor(private sanitizer: DomSanitizer) {}
  private sanitizer = inject(DomSanitizer);
  private dotCmsUveFacade = inject(DotCmsUveFacade);

  getVideoHeight$(contentlet: VideoContentlet): Observable<string> {
    return this.dotCmsUveFacade.getVideoHeight(contentlet);
  }

  iframeVideoUrl(contentlet: VideoContentlet) {
    return tryProcessVideo(contentlet, this.sanitizer);
  }

  getVideoClasses(contentlet: VideoContentlet) {
    return this.dotCmsUveFacade.getVideoClasses(contentlet);
  }
}
